import { Col, Layout, Row } from 'antd';
import { MainLayout } from 'modules/common/components';
import ForgotPasswordForm from 'modules/user/components/ForgotPasswordForm';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const ForgotPasswordPage: FC = () => {
  const { t } = useTranslation('user.ForgotPasswordPage');
  return (
    <MainLayout>
      <Layout.Content className={styles.content}>
        <Row justify="center" align="middle" className={styles.formContainer}>
          <Col span={24}>
            <h1 className={styles.title}>{t('forgotPassword')}</h1>
          </Col>
          <Col flex="440px">
            <ForgotPasswordForm />
          </Col>
        </Row>
      </Layout.Content>
    </MainLayout>
  );
};

export default ForgotPasswordPage;
